import { render, staticRenderFns } from "./captain_status.vue?vue&type=template&id=32c43d2d&scoped=true&"
import script from "./captain_status.vue?vue&type=script&lang=js&"
export * from "./captain_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c43d2d",
  null
  
)

export default component.exports